module.exports = __webpack_public_path__ + "img/gallery-nft-14.809bfc20.png";